/**
 * Shared palette for breakdown-style bars across the console:
 *   - Top campaigns leaderboard
 *   - Intent breakdown
 *   - Device / browser breakdowns
 *
 * Goals:
 *   - Distinct enough that rows are visually distinguishable at a glance.
 *   - Calm enough that a 6-row list doesn't look like a clown car
 *     (we tried `bg-primary` everywhere — too much purple; we tried
 *     `bg-foreground/40` everywhere — too uniform).
 *
 * Low-opacity `*-500/45` tints read well on both light and dark
 * surfaces and stay below the foreground text in contrast hierarchy.
 *
 * Used as a rotating ring — `paletteFor(i)` wraps with modulo.
 */
const BREAKDOWN_PALETTE = [
    'bg-violet-500/45',
    'bg-sky-500/45',
    'bg-emerald-500/45',
    'bg-amber-500/45',
    'bg-rose-500/45',
    'bg-fuchsia-500/45',
    'bg-teal-500/45',
];
export function paletteFor(index) {
    if (!Number.isFinite(index) || index < 0)
        return BREAKDOWN_PALETTE[0];
    return BREAKDOWN_PALETTE[index % BREAKDOWN_PALETTE.length];
}
export const BREAKDOWN_PALETTE_SIZE = BREAKDOWN_PALETTE.length;
